<template>
  <div class="invoice-container">
    <nav class="add-navigation flex-wrap">
      <div class="search-box ">
        <search-input
          v-model="Searched"
          placeholder="Search for SMSC Connection"
        />
      </div>
      <div class="buttons d-flex flex-wrap">
        <div class="restart button-margin-size ">
          <primary-button @click.native="restart">Restart</primary-button>
        </div>
        <div class="primary-button button-margin-size">
          <primary-button
            @click.native="
              $router.push({ name: 'system-admin-smsc-connection-add' })
            "
            >Add SMSC Connection</primary-button
          >
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <not-found v-else-if="isFound" />
    <template v-else>
      <!-- <div class="radios">
        <div class="client">
          <input type="radio" id="client" v-model="radioType" value="client" name="radio" />
          <label class="label" for="client">Client</label>
        </div>
        <div class="vendor">
          <input type="radio" id="vendor" v-model="radioType" value="vendor" name="radio" />
          <label class="label" for="vendor">Vendor</label>
        </div>
      </div> -->
      <div
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th>SMSC Connection</th>
              <th>Status</th>
              <th>Is Enabled</th>
              <th class="update_time">Update Time</th>
              <th>IP</th>
              <th>Username</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(smsc, k) in SmscList" :key="k">
              <th>{{ smsc.smsc_id }}</th>
              <th>{{ smsc.status }}</th>
              <th>{{ smsc.is_enabled ? 'True' : 'False' }}</th>
              <th class="update_time">{{ smsc.upd_time }}</th>
              <th>{{ smsc.ip }}</th>
              <th>{{ smsc.username }}</th>
              <th class="icon-right action">
                <!-- <svg
                  @click="restart(smsc.smsc_id)"
                  class="svg-grey restart"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 496 512"
                >
                  <path
                    fill="currentColor"
                    d="M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                  />
                </svg>-->
                <span title="Edit">
                  <svg
                          @click="
                    $router.push({
                      path:
                        '/system-admin/smsc-connection/edit-smsc-connection/' +
                        smsc.smsc_id,
                    })
                  "
                          class="svg-grey"
                          width="30px"
                          height="30px"
                          viewBox="0 0 30 30"
                          version="1.1"
                  >
                  <path
                          d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                          id="path-1"
                  />
                </svg>
                </span>
                <span title="Delete">
                  <svg
                          @click="deleteSmsc(smsc)"
                          class="svg-grey"
                          width="30px"
                          height="30px"
                          viewBox="0 0 30 30"
                          version="1.1"
                  >
                  <path
                          d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                          id="path-1"
                  />
                </svg>
                </span>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
        <div class="per-page">
          <span class="filter_by">Show Per Page:</span>
          <div class="perPage">
            <primary-select
              type="text"
              @input="changePerPage"
              class="perPage"
              v-model="per_page" :is-cross="false"
              placeholder="Select"
            >
              <option :value="item" v-for="(item, key) in pages" :key="key">
                {{ item }}
              </option>
            </primary-select>
          </div>
        </div>
        <div
          class="buttons-wrapper"
          :class="{ pagination: paginationCondition }"
        >
          <pagination-component
            @change-page="changePage($event)"
            :page="Page"
            :total="totalPages"
            :perPage="per_page"
            :qnt="SmscList.length"
          />
        </div>
      </div>
    </template>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    ></div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    vendors: [],
    types: [
      { name: "ALL", value: "ALL" },
      { name: "MO", value: "MO" },
      { name: "MT", value: "MT" },
    ],
    Page: 0,
    Searched: "",
    type: "ALL",
    pages: [10, 50, 100],
    per_page: 10,
    loading: true,
    isFound: false,
    timeout: null,
    // radioType: "client",
  }),
  filters: {
    snippet: function (v) {
      let length = v.length;
      if (length > 8) {
        return v.slice(0, 3) + "..." + v.slice(length - 5, length);
      } else {
        return v;
      }
    },
  },
  computed: {
    ...mapGetters({
      smscList: "smsc/getSmscList",
      totalPages: "smsc/getTotalPages",
    }),
    SmscList() {
      return this.smscList.map((item) => {
        return {
          ...item,
          upd_time: format(item.upd_time, "YYYY:MM:DD HH:mm:ss"),
        };
      });
    },
    paginationCondition() {
      return this.SmscList.length < this.per_page && this.Page === 0;
    },
  },
  watch: {
    Searched(searchedText) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.Page = 0;
        this.GetList();
      }, 800);
    },
  },
  created() {
    this.GetList();
  },
  methods: {
    ...mapActions({
      viewSmscList: "smsc/getSmscList",
      deleteItem: "smsc/deleteSmsc",
    }),
    restart(id) {
      this.$store
        .dispatch("Restart")
        .then((res) => {
          if (res.success) {
            this.$success("SMSC Connection has been restarted");
          }
        })
        .catch((err) => this.$error(err));
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    async GetList() {
      this.loading = true;
      this.isFound = false;
      const res = await this.viewSmscList({
        page: this.Page,
        per_page: this.per_page,
        searched_text: this.Searched,
      });
      console.log(res);
      this.loading = false;
      if (!res.items.length) {
        return (this.isFound = true);
      }
    },
    deleteSmsc(smsc) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this SMSC connection!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(async (result) => {
        if (result.value) {
          this.deleteItem(smsc.smsc_id)
            .then(() => {
              this.$swal({
                title: "Deleted!",
                text: "The SMSC Connection has been deleted.",
                type: "success",
              });
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-container {
  padding: 0 20px;

  .buttons-wrapper {
    display: flex;
    align-items: center;
    // width: fit-content;
    width: 100%;

    &.pagination {
      width: fit-content;
      flex-grow: 1;
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .filter_by {
      margin-right: 15px;
      color: #55616e;
      font-weight: normal;
      font-family: "Helvetica Neue";
      font-size: 14px;
    }
    .perPage {
      width: 120px;
    }
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: fit-content;
    margin-top: 20px;
    margin-bottom: 20px;

    .buttons {
      display: flex;

      .restart {
        margin-right: 15px;
      }
    }
    .search-box {
      width: 250px;

      .primary-input-container {
        background-color: #fff;
      }
    }
    .primary-button {
      height: 40px;
      width: 220px;
    }
  }
}
.label {
  margin-left: 6px;
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;
    padding-left: 0;
  }
  .action {
    width: 100px;

    .restart {
      padding: 3px;

      path {
        fill: #55616e;
      }
    }
  }
  .update_time {
    width: 240px;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  //  padding-left: 20px;
  //     padding-right: 30px;
  min-width: 25%;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 0px 0 20px;
  margin-right: 10px;
}
th.button {
  padding: 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}

tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 44px;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
  text-align: left;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
table thead th:first-child {
  // padding-left: 20px;
  // padding-right: 30px;
}
tbody th.break {
  max-width: 100px;
  word-wrap: break-word;
  padding-right: 15px;
  line-height: 20px;
  color: #55616e;
  font-family: "Helvetica Neue";
}
tbody th .did {
  width: 50px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
  padding: 0;
}
tbody th.icon-right {
  padding: 7px 0;
  div {
    display: flex;
    justify-content: flex-end;
  }
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 17px 12px 0 13px;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
.img-container {
  display: flex;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin: 7px 8px 7px 0;
}
.primary {
  // padding-top: 11px;
  width: 90px !important;
  height: 30px !important;
  font-size: 12px !important;
  line-height: 20px !important;
  border-radius: 100px !important;
  margin-right: 10px !important;
}
.primary.active {
  border: 2px solid #ffffff;
  border-radius: 100px;
  background-color: #24e2b8;
  color: #ffffff;
  padding: 0;
  // opacity: 0.68;
}
@media (max-width: 1458px) {
  table.Invoice_table {
    width: 1358px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
@media (max-width: 679px) {
  .button-margin-size{
    margin-top: 16px;
  }

}
</style>

